<div class="h-100 d-flex flex-column p-4">
    <div class="flex-shrink-0 mb-3">
        <dx-tabs
            [items]="tabs"
            [(selectedIndex)]="selectedTabId"
            (onItemClick)="onTabClick($event)"
            width="100%"
        ></dx-tabs>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'storage-unit-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll flex-grow-1">
        @if (!isLoading) {
            @if (selectedTabId === 0) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
                        <div class="card-header fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent py-3">
                            <div>General Information</div>
                            @if (storageUnit.number) {
                                <div class="text-muted">
                                    ID: {{ storageUnit.number }}
                                </div>
                            }
                        </div>
                        <div class="card-body">
                            <!-- General -->
                            <div class="mb-3 fs-6 fw-bold">General</div>
                            <div class="row g-3 mx-3">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Status:</span>
                                        <span
                                            class="badge"
                                            [ngClass]="getStatusBadgeClass(storageUnit.status)">{{ storageUnit.status | capitalCase }}
                                        </span>
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Storage Unit:</span> {{ storageUnit.number }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Batch:</span> {{ storageUnit.batch }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">SLED/BBD:</span> {{ storageUnit.sledBbd | date:'longDate' }}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Last Updated:</span> {{ storageUnit.lastModified | date:'medium' }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">First Added:</span> {{ storageUnit.created | date:'medium' }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Full | Partial:</span> {{ storageUnit.palletType | palletType }}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Storage Unit Type:</span> {{ storageUnit.storageUnitType }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">WM unit:</span> {{ storageUnit.wmUnit }}
                                    </div>
                                    <div class="mb-2">
                                        <span class="fw-bold me-2">Number of quants:</span> {{ storageUnit.numberOfQuants }}
                                    </div>
                                </div>
                            </div>

                            <hr class="my-4"/>

                            <!-- Materials -->
                            @for (material of storageUnit.materials; track material.number) {
                                <app-storage-unit-material [material]="material"></app-storage-unit-material>
                            }

                            <hr class="my-4"/>

                            <!-- Latest Storage Bin -->
                            <div class="mb-3 fs-6 fw-bold">Latest Storage Bin</div>
                            @if (storageUnit.latestBin) {
                                <div class="row g-3 mx-3">
                                    <div class="col-md-4">
                                        <div class="mb-2"><span class="fw-bold">Storage Bin:</span> {{ storageUnit.latestBin.number }}</div>
                                        <div class="mb-2"><span class="fw-bold">Storage Type:</span> {{ storageUnit.latestBin.storageTypeCode }}</div>
                                        <div class="mb-2"><span class="fw-bold">Storage Bin Type:</span> {{ storageUnit.latestBin.storageBinType }}</div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mb-2"><span class="fw-bold">Duration:</span> {{ storageUnit.duration }}</div>
                                        <div class="mb-2"><span class="fw-bold">Date Entered:</span> {{ storageUnit.dateEntered | date : 'medium' }}</div>
                                        <div class="mb-2"><span class="fw-bold">Type:</span> {{ storageUnit.latestBin.storageType }}</div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mb-2"><span class="fw-bold">Zone:</span> {{ storageUnit.latestBin.zone }}</div>
                                        <div class="mb-2"><span class="fw-bold">Max Pallets:</span> {{ storageUnit.latestBin.maxPallets }}</div>
                                        <div class="mb-2"><span class="fw-bold">Aisle:</span> {{ storageUnit.latestBin.aisle }}</div>

                                        @if (storageUnit.storageTypeCode == '955') {
                                            <div class="mb-2"><span class="fw-bold">Shipment #:</span> {{ storageUnit.shipmentNumber }}</div>
                                        }
                                    </div>
                                </div>
                            } @else {
                                <div class="mx-3 text-muted">No latest bin information.</div>
                            }
                        </div>
                    </div>
                </div>
            }
            @if (selectedTabId === 1) {
                <div class="px-3">
                    <app-storage-unit-history [historyData]="storageUnit.history"></app-storage-unit-history>
                </div>
            }
        }
    </dx-scroll-view>
</div>

